import { Component, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { InviteService } from '@se-po/shared-data-access-services'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { UserServiceResources as us } from 'se-resource-types'

@Component({
  selector: 'se-po-minor-account-repeat',
  templateUrl: './minor-account-repeat.component.html',
  styleUrls: ['./minor-account-repeat.component.scss'],
})
export class MinorAccountRepeatComponent implements OnInit {
  public form: FormGroup
  public inviteId: string
  public invite: us.Invitation
  public ready = false
  public submitting = false
  public toEmailAddress?: string
  public error = false
  public menuOptions = {
    name: 'inviteMenu',
    sections: [{
      menuItems: [{
        text: 'Resend',
        action: () => this.resendInvite(),
      }, {
        text: 'Cancel',
        action: () => this.cancelInvite(),
      }]
    }]
  }

  constructor(
    private inviteService: InviteService,
    private route: ActivatedRoute,
    private router: Router,
    private setupService: SetupBarService,
  ) {}

  public ngOnInit(): void {
    this.error = false
    this.inviteId = this.route.snapshot.params.id
    this.setupService.percentComplete = 75
    this.inviteService.find(this.inviteId, { status: 'sent' }).subscribe({
      next: invite => {
        this.invite = invite
        this.toEmailAddress = invite.email_address?.address
        this.ready = true
      },
      error: () => this.router.navigate(['/minor-account', 'not-found'])
    })
  }

  public resendInvite(): void {
    this.submitting = true
    this.error = false
    this.inviteService.resend(this.inviteId).subscribe({
      next: () => {
        this.router.navigate(['/minor-account', 'invite', 'sent'])
        this.submitting = false
      },
      error: () => {
        this.error = true
        this.submitting = false
      }
    })
  }

  public cancelInvite(): void {
    this.submitting = true
    this.error = false
    this.inviteService.cancel(this.invite.token).subscribe({
      next: (invite) => {
        this.router.navigate(['/minor-account', 'invite', invite.token])
        this.submitting = false
      },
      error: () => {
        this.submitting = false
        this.error = true
      }
    })
  }

  public dismissError(): void {
    this.error = false
  }
}
